import { ApiReferenceReact } from "@scalar/api-reference-react";
import "@scalar/api-reference-react/style.css";

/**
 * Read-only OpenAPI renderer backed by Scalar.
 *
 * We deliberately disable the interactive request features:
 *   - hideTestRequestButton: removes the "Test Request" button that fires a live
 *     HTTP call from the browser (also hides the auth panel, which is only
 *     relevant when sending real requests).
 *   - hideClientButton: removes the "Open API Client" entry points.
 *
 * The multi-language code snippets (curl, Python, JS, ...) are NOT clients that
 * send requests — they are static examples generated from the spec, so they
 * stay visible. Do NOT set `hiddenClients: true`, which would remove those
 * snippets entirely.
 */
export const ScalarApiDefinition = ({ definition }: { definition: string }) => (
  <div style={{ minHeight: "70vh" }}>
    <ApiReferenceReact
      configuration={{
        content: definition,
        hideTestRequestButton: true,
        hideClientButton: true,
      }}
    />
  </div>
);
